import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive } from "common/reducers/Utils";
import { hoverJobFromJSON, HoverJobRecord } from "common/records/HoverJob";
import { HoverActions, RECEIVE_HOVER_JOB, RECEIVE_HOVER_JOBS } from "common/reducers/hover.actions";

export const HoverStateRecord = Record({
  lastSavedById: Map<number, HoverJobRecord>(),
  byId: Map<number, HoverJobRecord>(),
});

export const initialState = HoverStateRecord();

const model = "hoverJobs";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_HOVER_JOB:
      return receive(state, model, hoverJobFromJSON(action.payload.job));

    case RECEIVE_HOVER_JOBS:
      action.payload.jobs.forEach((job) => {
        state = reducer(state, HoverActions.receiveHoverJob(job));
      });
      return state;

    default:
      return state;
  }
};
